// -----------------  GET INFO STATIC CONTENT -----------------
export const STATIC_CONTENT_LOADING = 'STATIC_CONTENT_LOADING';
export const STATIC_CONTENT_SUCCESS = 'STATIC_CONTENT_SUCCESS';
export const STATIC_CONTENT_ERROR = 'STATIC_CONTENT_ERROR';
